import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Responsable du traitement",
    body: [
      "Le responsable du traitement des données à caractère personnel est DK Soins SRL (marque AVELIS), Route de Gosselies 27/8, 6220 Fleurus, Belgique — BCE 1008.815.935.",
      "Contact pour toute question relative à vos données : contact@avelis.be — +32 489 56 78 88.",
    ],
  },
  {
    title: "Données que nous traitons",
    body: [
      "Ce site ne comporte aucun formulaire de collecte. Le seul traitement de données personnelles intervient lorsque vous contactez AVELIS de votre propre initiative, par téléphone, WhatsApp ou e-mail.",
      "Dans ce cadre, nous traitons uniquement les données que vous nous communiquez : identité, coordonnées (numéro de téléphone, adresse e-mail) et contenu de votre demande.",
      "Le site ne collecte aucune donnée de santé ni aucune donnée relative à des patients. Merci de ne transmettre aucune donnée médicale ou donnée personnelle concernant vos patients lors de vos échanges avec AVELIS.",
    ],
  },
  {
    title: "Finalités et bases légales",
    body: [
      "Vos données sont utilisées exclusivement pour répondre à votre demande et, le cas échéant, préparer et exécuter la prestation de tarification convenue.",
      "Base légale : l'exécution de mesures précontractuelles ou contractuelles (article 6.1.b du RGPD) et notre intérêt légitime à répondre aux demandes entrantes (article 6.1.f du RGPD).",
    ],
  },
  {
    title: "Durée de conservation",
    body: [
      "Les données liées à une demande de contact sont conservées pendant la durée nécessaire au traitement de votre demande et aux échanges qui en découlent, puis pendant la durée des obligations légales de conservation applicables en cas de relation contractuelle.",
    ],
  },
  {
    title: "Destinataires et transferts",
    body: [
      "Vos données sont accessibles uniquement aux personnes habilitées de DK Soins SRL. Elles ne sont ni vendues, ni louées, ni transmises à des tiers à des fins commerciales.",
      "Si vous choisissez de nous contacter via WhatsApp, vos échanges transitent par les services de Meta Platforms, soumis à leurs propres politiques de confidentialité et susceptibles d'impliquer des transferts hors de l'Union européenne encadrés par des clauses contractuelles types.",
    ],
  },
  {
    title: "Vos droits",
    body: [
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation du traitement, d'opposition et de portabilité de vos données, ainsi que du droit de retirer votre consentement lorsque le traitement repose sur celui-ci.",
      "Pour exercer ces droits : contact@avelis.be. Nous répondons à toute demande dans un délai d'un mois.",
      "Vous pouvez également introduire une réclamation auprès de l'Autorité de protection des données (APD) : Rue de la Presse 35, 1000 Bruxelles — contact@apd-gba.be — www.autoriteprotectiondonnees.be.",
    ],
  },
  {
    title: "Sécurité",
    body: [
      "Nous appliquons des mesures techniques et organisationnelles appropriées pour protéger vos données : accès restreint aux personnes habilitées, communications chiffrées et bonnes pratiques de sécurité de l'information.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "Pour toute information sur les cookies, consultez notre page « Gestion des cookies » accessible en bas de chaque page.",
    ],
  },
  {
    title: "Modifications",
    body: [
      "La présente politique peut être mise à jour pour refléter l'évolution de nos pratiques ou du cadre légal. La date de dernière mise à jour figure en haut de cette page.",
    ],
  },
];

const Confidentialite = () => (
  <>
    <Seo
      title="Politique de confidentialité | AVELIS"
      description="Politique de confidentialité AVELIS (DK Soins SRL) : données traitées, finalités, durées de conservation et droits RGPD."
    />
    <section data-testid="privacy-page" className="pt-[130px] sm:pt-[160px] pb-16 sm:pb-24 bg-[#f6f3ec]">
      <div className="container-avelis max-w-3xl">
        <Reveal>
          <p className="eyebrow"><span className="dot-sage" />Légal</p>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0d2731]">Politique de confidentialité</h1>
          <p className="mt-5 text-sm text-[#4b585e]">Dernière mise à jour : octobre 2026</p>
          <div className="mt-10 space-y-10">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="text-xl font-extrabold tracking-tight text-[#0d2731]">{s.title}</h2>
                <div className="mt-3 space-y-2">
                  {s.body.map((p, i) => (
                    <p key={i} className="text-sm sm:text-base text-[#4b585e] leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Confidentialite;
